import { useEffect } from "react";

/**
 * Custom hook for handling GHL (Go High Level) form embed script loading
 * This hook manages the lifecycle of the GHL form embed script
 */
const useGhlFormEmbed = () => {
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://link.msgsndr.com/js/form_embed.js";
    script.async = true;
    document.body.appendChild(script);

    return () => {
      const existingScript = document.querySelector('script[src="https://link.msgsndr.com/js/form_embed.js"]');
      if (existingScript) {
        document.body.removeChild(existingScript);
      }
    };
  }, []);
};

export default useGhlFormEmbed;
